"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewTagsContainer = void 0;
var React = require("react");
var container_1 = require("./container");
var charts_1 = require("./charts");
var App_1 = require("../../App");
var typestyle_1 = require("typestyle");
var OverviewTagsContainer = (function (_super) {
    __extends(OverviewTagsContainer, _super);
    function OverviewTagsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewTagsContainer.prototype.render = function () {
        var self = this;
        var props = this.props;
        var piechartData = props.category.values;
        var tagCount = props.category.values.length;
        var tagAvgSize = (props.category.values.map(function (x) { return x.label.length; }).reduce(function (a, b) { return a + b; })
            / tagCount);
        var bigPiechartModifier = tagCount > 10 || tagAvgSize > 15 ? "PieChart--big" : "";
        var horizontalBarPlotData = [props.category];
        return (React.createElement(container_1.Container, { containerSubTitle: props.category.key, borderless: true },
            React.createElement(container_1.Container, { borderless: true },
                React.createElement(charts_1.PieChart, { data: piechartData, className: (0, typestyle_1.classes)(bigPiechartModifier), onElementClick: self.onClick.bind(self) })),
            React.createElement(container_1.Container, { borderless: true },
                React.createElement(charts_1.MultiBarHorizontalChart, { data: horizontalBarPlotData, onElementClick: self.onClick.bind(self), heightModifier: 20, showLegend: false, showXAxis: true, showYAxis: false, showTooltip: true, xAxisWide: true }))));
    };
    OverviewTagsContainer.prototype.onClick = function (obj) {
        App_1.store.editableListDialog.openDialog(this.props.title, obj.data);
    };
    return OverviewTagsContainer;
}(React.Component));
exports.OverviewTagsContainer = OverviewTagsContainer;
